import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CoreButton from '@components/Buttons/CoreButton';
import ExclamationTriangleIcon from '@heroicons/react/24/solid/ExclamationTriangleIcon';
import { styled } from '@mui/system';
const Container = styled('div') `
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  margin: 16px 0 48px;

  p {
    margin: 0;
    text-align: center;
  }
`;
const IconWrapper = styled('div') `
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.error.light};

  svg {
    color: ${({ theme }) => theme.palette.error.main};
    width: 48px;
    height: 48px;
  }
`;
const Heading = styled('p') `
  font-weight: 600;
  font-size: 18px;
`;
const Content = styled('p') `
  font-weight: 500;
  font-size: 13px;
`;
const StyledCoreButton = styled(CoreButton) `
  margin-top: 12px;
`;
const RegistrationDisabled = () => {
    return (_jsxs(Container, { children: [_jsx(IconWrapper, { children: _jsx(ExclamationTriangleIcon, {}) }), _jsx(Heading, { children: "New account registration is disabled" }), _jsx(Content, { children: "Repeat is winding down operations and is no longer accepting new account registrations. If you already have an account, you can still log in." }), _jsx(StyledCoreButton, { size: "lg", to: "https://www.repeat.gg/content/repeat-closing", target: "_blank", children: "Learn more" })] }));
};
export default RegistrationDisabled;
